function useStyles() {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            padding: '24px 0',
            margin: '0',
            gap: 2,
            '&.h-full': {
                height: '100%'
            },
            '& .break-w': { wordBreak: 'break-word' },
        },
        detailTitle: {
            '& .detail-value': {
                fontSize: '16px',
                fontWeight: '800',
                color: 'c_grey.main'
            },
        },
        detailItem: {
            '& .detail-value': {
                fontSize: '18px',
                fontWeight: 'initial'
            },
        },
    }
}

export { useStyles }